/**
 * login Group
 * @param fb : FormBuilder
 */
export function loginGroup (fb: any) {
    return fb.group({
        uid: [''],
        pwd: ['']
    })
}
